<script setup lang="ts">
// Association branding bar — mounted in App.vue so it also frames /return and
// the error/unavailable states, not just the happy purchase path.
</script>

<template>
  <header class="border-b border-slate-200 bg-white">
    <div class="mx-auto flex max-w-5xl items-center gap-3 px-4 py-3">
      <img
        src="/brand/logo-ev-kaiseraugst.svg"
        :alt="$t('buy.brand.logoAlt')"
        class="h-10 w-auto"
        width="234"
        height="300"
      />
      <span class="text-base font-semibold text-slate-900">
        {{ $t("buy.brand.name") }}
      </span>
    </div>
  </header>
</template>
